import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';


export default class AddUser extends Component {
constructor(props) {
    super(props);
	
	 this.state = {usid:'',us_id:0,open:false,data:[],redirect: false,details:'',btndisabled:false,submitbtn:"Submit",isactive:'',
userdata:[],logredirect:false,pagename:'',Role:"",rolelabel:'Select Role',name:"",emailid:"",phone:"",passwords:"",usercmpid:"",code:'',exitpwd:'',
submitbtn:"Submit"  
      }
   
}


  
 Usergetgetdata() {
	
  if(this.props.id!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxuser.php?action=getall&us_id='+this.props.id)
	  
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
     usid:resp.data[0].us_id,
		name:resp.data[0].us_firstname,
		names:resp.data[0].us_lastname,
		email:resp.data[0].us_emailid,
		phone:resp.data[0].us_phone,
		exitpwd:resp.data[0].us_password,
		code:resp.data[0].us_code,
		Role:resp.data[0].us_role,
		usercmpid:resp.data[0].us_cmp_id
		
    });
	
  }

});
	  
  }else{
	 this.setState({  
	 usid:0,
	 name:'',
		names:'',
		email:'',
		phone:'',exitpwd:'',
		passwords:'',
		code:'',
		Role:'',
		usercmpid:'',
	  }); 
 }
  
    }
	
	handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  name:'',names:'',phone:'',passwords:'',usid:'',
	 code:'',Role:'',usid:'', usercmpid:'',
     errormessage:'',erropen:false,
	  });
		
		
this.Usergetgetdata();

};
onclickuserclose = (e) => {
	 this.setState({open:false});
	 
} 
myChangeHandler = (event) => {
 
   const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if(nam==="phone")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else{
	  
	   this.setState({[nam]: val});
  }
 
  
}
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }










  handleSubmit= (event) => {
	

    event.preventDefault();
	
	let name=this.state.name;
	let names=this.state.names;
	let email=this.state.email;
	let phone=this.state.phone;
	let passwords=this.state.passwords;
	let code=this.state.code;
	let Role=this.state.Role;
	let usercmpid=this.state.usercmpid;
	

 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
if(name==="")
{
	this.setState({errormessage:"Please Enter First Name",erropen:true});
	return false;
}
if(names==="")
{
	this.setState({errormessage:"Please Enter Last Name",erropen:true});
	return false;
}

if(phone==="")
{
	this.setState({errormessage:"Please Enter Phone.",erropen:true});
	return false;
}
if(email==="")
{
	this.setState({errormessage:"Please Enter Email.",erropen:true});
	return false;
}else{
	
	 if (!remail.test(email)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
  }
  
 if(passwords==="" && this.state.exitpwd==="")
{
	this.setState({errormessage:"Please Enter Password.",erropen:true});
	return false;
}
 if(code==="")
{
	this.setState({errormessage:"Please Enter Code.",erropen:true});
	return false;
}
 if(Role==="")
{
	this.setState({errormessage:"Please Select Role.",erropen:true});
	return false;
}


}
this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	 if(this.state.usid!=="")
	 {
	  
	  formData.append('us_id',this.state.usid)
	 }else
	 {
		formData.append('us_id',0)  
	 }
	 formData.append('action','insertorupdate')
    formData.append('us_firstname',name)
	 formData.append('us_lastname',names)
	 formData.append('us_emailid',email)
	 formData.append('us_phone',phone)
	 formData.append('us_password',passwords)
	  formData.append('us_code',code)
	 formData.append('us_role',Role)
	 formData.append('us_cmp_id',localStorage.getItem("ISIcmpid"))
	 formData.append('userid',localStorage.getItem("ISIuserid"))
	
	  		
	
	  
	 axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
        }).then(res => {
			
			if(res.data == -1)
{ 
		this.setState({errormessage:"User Already Exist.",erropen:true,btndisabled:false,
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
			this.setState({errormessage:"",erropen:false,open:false,btndisabled:false,
submitbtn:"Submit",
		});
			this.props.parentuserinsert(res.data);
	}   
   });    
  };


  
render() {
  if (this.state.logredirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  return (
    <React.Fragment>
     
    

      <Dialog open={this.state.open} onClose={this.onclickuserclose} maxWidth="md" fullWidth className="popup" aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Create User</DialogTitle>
        <DialogContent>
          <p>
            <Collapse in={this.state.erropen}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => this.handleErrorclose()}
                  >
                    {/* Close button content */}
                  </IconButton>
                }
                severity="error"
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>
          </p>

          <div className="customerform">
            <ul>
              <li>
                <p>First Name <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="name"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.name}
                    inputProps={{ tabIndex: "1", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Last Name <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="names"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.names}
                    inputProps={{ tabIndex: "2", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Email: <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="email"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.email}
                    inputProps={{ tabIndex: "3", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Phone No: <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="phone"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.phone}
                    inputProps={{ tabIndex: "4", maxLength: 15 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Password <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="passwords"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.passwords}
                    type="Password"
                    inputProps={{ tabIndex: "5", maxLength: 50 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Code <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="code"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.code}
                    type="Code"
                    inputProps={{ tabIndex: "6", maxLength: 10 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p><span className="validation">*</span> Role</p>
                <p>
                  <FormControl className="stadrp">
                    <Select
                      native
                      variant="outlined"
                      margin="normal" value={this.state.Role}
                      onChange={this.myChangeHandler}
                      id="type"
                      inputProps={{ tabIndex: "7" }}
                      className="txtbox"
                      name="Role"
                    >
                      <option value="">Select Role</option>
                      <option value={1}>Admin</option>
                      <option value={2}>Manager</option>
                      <option value={3}>Sales</option>
                    </Select>
                  </FormControl>
                </p>
              </li>
            </ul>
          </div>


          <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickuserclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" disabled={this.state.btndisabled} className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
}